// @flow
import React, { PureComponent } from 'react';
import type { ArticleType, CategoryArticleType } from 'types/Article';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { State as SidebarType } from 'reducers/sidebarReducer';
import { getPublicAssets } from 'utils/assetsUtils';
import BillBoardCard from 'components/billboard/BillboardCard';
import SideBillboardCard from 'components/billboard/SideBillboardCard';
import NewsByTheme from 'components/newsletter/NewsByTheme';
import SideBar from 'components/sidebar/Sidebar';
import Themes from 'containers/newsletter/ThemesContainer';
import { ARTICLE_NB_NEWSLETTER } from 'constants/articleConstants';
import Breadcrumb from 'components/fragments/Breadcrumb';
import { getMetaBySlug } from 'utils/seoUtils';

export type DispatchProps = {
  fetchArticles: (page: number, per_page: number) => void,
  fetchArticlesCategories: (page: number, per_page: number) => void,
  fetchGenericSidebar: () => void,
};

export type StateProps = {
  categoriesArticle: CategoryArticleType[],
  news: ArticleType[],
  sidebar: SidebarType,
  status: string,
  ligue: string
};

type Props = StateProps & DispatchProps;

class Newsletter extends PureComponent<Props>{

  componentDidMount(){
    this.props.fetchArticles(1, ARTICLE_NB_NEWSLETTER);
    this.props.fetchArticlesCategories(1, ARTICLE_NB_NEWSLETTER);
    this.props.fetchGenericSidebar();
  }

  renderNews = (news: ArticleType[]): any => {
    return news.map((news, index): any => {
      return <SideBillboardCard key={index} content={news} />;
    });
  }

  renderNewsByTheme = () => {
    const { categoriesArticle } = this.props;

    return categoriesArticle.map((category, index) => {
      if (category.items.length > 0) {
        return <NewsByTheme
                key={index}
                news={category.items}
                theme={category.name}
                url={`/actualites/${category.slug}`} />;
      }
      return null;
    });
  }

  renderSidebar = () => {
    const { sidebar } = this.props;
    return (
      <SideBar
        sidebarContent={sidebar.data}
        status={sidebar.status} />
    );
  }

  render(){
    const { news } = this.props;

    return (
      <React.Fragment>
        <section className="banner ">
          <div
            className="banner__thumbnail img-green"
            style={{ backgroundImage: `url(${getPublicAssets('/img/banner/hub-actualite.jpg')})` }}
          />
          <div className="container">
            <Breadcrumb elements={[{ name: 'Accueil', to: '/' }, 'Actualités']} isDark={true} />
            <h1 className="ft-h2">Dernières actualités</h1>
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <div className="row">
                  <div className="col col-lg-8on9 banner-over">
                    <BillBoardCard content={news[0]} containerStyle={'mb-4 mb-md-2 mb-lg-5'} />
                  </div>
                  <div className="col col-lg-8on9">
                    <div className="news-slider mb-6 mb-md-7">
                      <div className="news-slider__wrapper">{this.renderNews(news.slice(1))}</div>
                    </div>
                  </div>
                </div>
                <Themes />
                {this.renderNewsByTheme()}
              </section>
            </div>
            {this.renderSidebar()}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withHelmet(Newsletter)((Helmet, pageProps) => {
  const meta = getMetaBySlug(pageProps.location.pathname);
  return (
    <Helmet>
      <title>{meta.title(pageProps.ligue)}</title>
      <meta name={'description'} content={meta.description(pageProps.ligue)} />
      <link rel={'canonical'} href={window.location.href} />
      <meta property={'og:title'} content={meta.title(pageProps.ligue)} />
      <meta property={'og:description'} content={meta.description(pageProps.ligue)} />
    </Helmet>
  );
});
